import { FC } from 'react'
import {
	useLocation,
	useNavigate,
	useParams,
	useResolvedPath,
} from 'react-router-dom'

import Tabs from '~/components/Tabs'

import { useEarn } from '~/lib/useEarns'
import { pathToEarnPage } from '~/lib/routes'
import { useMatch } from 'react-router'

const Navigation: FC = () => {
	const navigate = useNavigate()
	const { earnType } = useEarn()
	const {
		params: { page },
	} = useMatch('/lp-farm/:earnType/:page')

	const handleChangeTab = ({ id: page }) => {
		navigate(pathToEarnPage(earnType, page))
	}

	return (
		<nav>
			<Tabs
				defaultActive={page}
				tabs={[
					{
						id: 'stake',
						name: 'STAKE',
					},
					{
						id: 'unstake',
						name: 'UNSTAKE',
					},
					{
						id: 'claim',
						name: 'CLAIM',
					},
				]}
				onChange={handleChangeTab}
			/>
		</nav>
	)
}

export default Navigation
